import { setClusterAttributes as setClusterAttributesDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    attributes?: [],
    reProcess?: boolean
}

export const setClusterAttributes = ({
    attributes,
    reProcess,
    eventEmitter,
}: Props) => {
   
    setClusterAttributesDiagram(attributes)
    if (reProcess === true) apiProvider.updateDiagramCluster({source: 'setClusterAttributes'});

};

